import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { CartState } from "../Context/Context";
import ProductContext from "../Context/productContext";
import "../Styles/ProductDetails.css";

export default function ProductDetails() {

  const {
    state: { cart },
    dispatch,
  } = CartState();
  const context = useContext(ProductContext);
  const location = useLocation();
  // const [size, setSize] = useState('UK7');
  const { fetchProductTitle, productTitle } = context;
  // console.log(productTitle);
  const { item } = location.state;
  // console.log(item);
  const [color, setColor] = useState(item.color);
  const [stock,setStock]=useState(item.stock);
  const [error, setError] = useState({
    color:'2',
  })

  const [showProducts, setShowProducts] = useState({
    id: "",
    code:"",
    title: "",
    description:"",
    size:"",
    stock:"",
    price: "",
    specialprice: "",
    color: "",
    image: "",
  //  size:""
  });

  useEffect(() => {
    fetchProductTitle(item.title);
    
  }, []);

  const showColorProduct = (color) => {
    setColor(color);
    productTitle.map((item) => {
      if (color === item.color) {
        setShowProducts({
          id: item.id,
          code:item.productcode,
          title: item.title,
          description:item.description,
          size:item.size,
          stock:item.stock,
          price: item.price,
          specialprice: item.specialprice,
          color: item.color,
          image: item.image,
          // size:size
        });
        setStock(item.stock)
      }
    });
  };  
  return (
    <>
      <div style={{ height: "108px" }}></div>

      <div className="product-details-page container-fluid">
        <div className="row">
          <div className="col-8">
            <img
              src={showProducts.image === "" ? item.image : showProducts.image}
              alt=""
              className="product-img"
            />
          </div>
          <div className="col-4">
            <div className="product-content">
              <div className="product-heading">
                <h2>
                  {showProducts.title === "" ? item.title : showProducts.title}
                </h2>
                <h5>
                  ₹{" "}
                  {showProducts.price === "" ? item.price : showProducts.price}
                </h5>
                <h4>
                  ₹{" "}
                  {showProducts.specialprice === ""
                    ? item.specialprice
                    : showProducts.specialprice}
                </h4>
              </div>


              <div className="size-container">
                <p className="product-item-title">AVAILABLE SIZE</p>
                <button
                      type="button"
                      className="btn"
                      style={{width:'30%'}}
                    >
                       {showProducts.size === ""
                    ? item.size
                    : showProducts.size}
                    </button>

                {/* <ul>
                  <li>
                    <button
                      type="button"
                      className="btn"
                      style={{backgroundColor:size==='UK7'?'#E4E4F7':'white'}}
                      onClick={() => {
                        setSize("UK7");
                        setColor('');
                        setError({size:''});
                      }}
                    >
                      UK 7
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      className="btn"
                      style={{backgroundColor:size==='UK8'?'#E4E4F7':'white'}}

                      onClick={() => {
                        setSize("UK8");
                        setColor('');
                        setError({size:''})

                      }}
                    >
                      UK 8
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      className="btn"
                      style={{backgroundColor:size==='UK9'?'#E4E4F7':'white'}}

                      onClick={() => {
                        setSize("UK9");
                        setColor('');
                        setError({size:''})

                      }}
                    >
                      UK 9
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      className="btn"
                      style={{backgroundColor:size==='UK10'?'#E4E4F7':'white'}}

                      onClick={() => {
                        setSize("UK10");
                        setColor('');
                        setError({size:''})

                      }}
                    >
                      UK 10
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      className="btn"
                      style={{backgroundColor:size==='UK11'?'#E4E4F7':'white'}}

                      onClick={() => {
                        setSize("UK11");
                        setColor('');
                        setError({size:''})

                      }}
                    >
                      UK 11
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      className="btn"
                      style={{backgroundColor:size==='UK12'?'#E4E4F7':'white'}}

                      onClick={() => {
                        setSize("UK12");
                        setColor('');
                        setError({size:''})

                      }}
                    >
                      UK 12
                    </button>
                  </li>
                </ul> */}
              </div>



              <div className="color-selector">
                <p className="product-item-title">COLOR</p>
                <ul>
                  {productTitle.map((item) => {
                    return (
                      <button
                      key={item.id}
                        className="btn"
                        style={{backgroundColor:color===item.color?'#E4E4F7':'white'}}
                        onClick={() => {showColorProduct(item.color);setError({color:''})}}
                      >
                        {item.color}
                      </button>
                    );
                  })}
                </ul>
                <p style={{color:'red',fontSize:'12px'}}>{error.color==='1'?'Please Select Color':null}</p>
              </div>

              
              {/* <p>Available Stock : {showProducts.stock === ''
                    ? item.stock
                    : showProducts.stock}</p>  */}
                    { stock===0 || stock === "0" ? <p>Out Of Stock</p> :<p>Available Stock : {stock}</p>}

              <div className="cart-btn d-grid"> 
                {cart.some(
                  (p) =>
                    p.id ===
                    (showProducts.id === "" ? item.id : showProducts.id)
                ) ? (
                  <button
                  style={{backgroundColor:'gray'}}

                    onClick={() => {
                      dispatch({
                        type: "REMOVE_FROM_CART",
                        payload: showProducts.id === "" ? item : showProducts,
                      });
                    }}
                  
                  >
                    REMOVE FROM CART
                  </button>
                ) : (
              
                  <button
                  disabled={stock===0||stock==="0"}
                  style={{ backgroundColor: "#032044" }}
                    onClick={() => {
                      console.log(stock);
                      if(!color){
                          setError({color:'1'});
                      }
                      // if(error.color === ''){

                        dispatch({
                          type: "ADD_TO_CART",
                          payload: showProducts.id === "" ? item : showProducts,
                        });
                      // }
                    }}
                  >
                    ADD TO CART
                  </button>
                )}
              </div>

              <div className="product-description">
                <p className="product-item-title"> DESCRIPTION :</p>
                <p style={{fontSize:"14px"}}> {showProducts.description === ""
                    ? item.description
                    : showProducts.description}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
